import { Id, Model, Ref } from "./model";
import { User, UserBase, UserDAO } from "./user";

export type AuthProviderKind = "google" | "microsoft" | "guest" | "email" | "teams" | "apple";

export const DEFAULT_AUTH_PROVIDER_KINDS: AuthProviderKind[] = ["google", "microsoft", "apple"];

export interface UserAuthProviderDataBase {
	kind: AuthProviderKind;
	sub: string;
	email?: string;
}

export interface UserAuthProviderDataTeams extends UserAuthProviderDataBase {
	kind: "teams";
	tenantId: string;
	objectId: string;
}

export interface UserAuthProviderDataEmail extends UserAuthProviderDataBase {
	kind: "email";
	passwordHash: string;
}

export interface UserAuthProviderDataGoogle extends UserAuthProviderDataBase {
	kind: "google";
}

export interface UserAuthProviderDataMicrosoft extends UserAuthProviderDataBase {
	kind: "microsoft";
}

export interface UserAuthProviderDataGuest extends UserAuthProviderDataBase {
	kind: "guest";
}

export interface UserAuthProviderDataApple extends UserAuthProviderDataBase {
	kind: "apple";
}

export type UserAuthProviderData =
	| UserAuthProviderDataTeams
	| UserAuthProviderDataEmail
	| UserAuthProviderDataGoogle
	| UserAuthProviderDataMicrosoft
	| UserAuthProviderDataGuest
	| UserAuthProviderDataApple;

export interface UserAuthProviderBase extends Model {
	__entity?: "UserAuthProvider";

	data: UserAuthProviderData;
	user: Ref<UserBase>;
}

export interface UserAuthProvider extends UserAuthProviderBase {
	user: Ref<User>;
}

export interface UserAuthProviderDAO extends UserAuthProviderBase {
	user: Id<UserDAO>;
}
